<script>
  import Block from './block.svelte'

  export let height = undefined
  export let width = undefined
  export let minWidth = undefined
  export let minHeight = undefined
  export let border = 1
  export let borderRadius = undefined
  export let borderColor = undefined
  export let leftBorder = undefined
  export let rightBorder = undefined
  export let padding = 0
  export let color = undefined
  export let backgroundColor = undefined
  export let hoverColor = undefined
  export let hoverBgColor = undefined
  export let activeColor = undefined
  export let activeBgColor = undefined
  export let fontSize = undefined
  export let bold = false
  export let fontWeight = undefined
  export let textAlign = 'center'
  export let lineHeight = undefined
  export let cursor = 'pointer'
</script>

<Block
  {height}
  {width}
  {minHeight}
  {minWidth}
  {border}
  {borderRadius}
  {borderColor}
  {leftBorder}
  {rightBorder}
  {color}
  {backgroundColor}
  {hoverColor}
  {hoverBgColor}
  {activeColor}
  {activeBgColor}
  {fontSize}
  {bold}
  {fontWeight}
  {textAlign}
  {cursor}
  {padding}
  {lineHeight}
  selectable={false}
  display=inline-block
  on:click
>
  <slot></slot>
</Block>



